import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Loading from './Loading';
import NavBar from '../../components/NavBar';

const LoginForm = ( { setShowOtp, email, setEmail } ) => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Send the data to the API
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/login`, {
        email,
      });

      // Handle success
      setShowOtp(true);
    } catch (error) {
      if (error.response) {
        // Server-side error, log the details
        console.log('Login failed:', error.response.data);
        setMessage(error.response.data.message);
        setLoading(false);
      } else {
        // Client-side or network error
        console.log('Error occurred:', error.message);
        setLoading(false);
      }
    }
  };

  return (
    <div>
      <NavBar />
      {loading ? (
        <Loading />
      ):(
        <div className="min-h-screen flex md:items-center justify-center pt-28 bg-white md:bg-gray-100">
          <div className="bg-white p-6 rounded md:shadow-md w-full max-w-md ">
            <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="email" className="block text-gray-700">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter admin email address"
                  className="w-full px-3 py-2 border rounded"
                  required
                />
              </div>
              <p className='my-4 text-red-500'>{message}</p>
              <button
                type="submit"
                className="w-full btn-primary transition"
                disabled={loading} // Disable button while loading
              >
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </form>
            {/* <p className="mt-4 text-center">
              Don't have an account? <Link to="/register" className="text-button1">Register</Link>
            </p> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
